import React, { Component } from 'react'
import "./industrialMap.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { message } from 'antd'
import { getApiMapList } from '../../axios/api'
import { get } from '../../axios/localstorage'

export default class industrialMap extends Component {

    state = {
        list:[],
        loginType:false,
    }

    hideLoginType=()=>{

        
        this.setState({
            loginType:false
        })
    }

    componentWillMount(){
        window.scroll(0,0);

        getApiMapList({token:get('token')})
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    list:data
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    render() {
        return (
            <div className='industrialMap'>
                <Header type={3} loginType={this.state.loginType} hideLoginType={this.hideLoginType} />
                <div className='head'>
                    <div className='cen'>
                        <div className='main'>
                            <div className='name'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>产业图谱</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='page'>
                    <div className='cen'>
                        <div className='main'>
                            <div className='pdiv'>
                                <div className='pleft'>
                                    <img alt="" src="/www/assets/imgs/chanye.png" />
                                    <h2>玄武区产业地图</h2>
                                    <div>
                                        <p>立即查看</p>
                                        <img alt="" src="/www/assets/imgs/lijichakan.png" />
                                    </div>
                                </div>
                                <div className='pright'>
                                    {
                                        this.state.list.map((item,index)=>{
                                            return <div className='pri' key={index} onClick={()=>{
                                                if(!get('token')){
                                                    // message.info("请先登录")
                                                    this.setState({
                                                        loginType:true
                                                    })
                                                    return false;
                                                  }

                                                  if(!item.is_true){
                                                      message.info('暂未开通');
                                                      return false;
                                                  }
                                                window.open(item.url);
                                            }}>
                                                        <div className='picon'>
                                                            <img alt="" src={item.image} />
                                                        </div>
                                                        <div className='ptext'>
                                                            <h2>{item.title}</h2>
                                                            <p>{item.tags}</p>
                                                        </div>
                                                    </div>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
